import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'

const allowanceService = {
    getAllowancePendingCount: async () => {
        return axios.get(`${baseUrl}/allowances/count/pending`)
    },
    getAllowanceDashboardCount : async () => {
        return axios.get(`${baseUrl}/allowances/calculate/total`)
    },
    fetchAllowanceRequests: (body) => axios.post(`${baseUrl}/allowances/web/list`, body),
    updateAllowanceStatus: (body) => axios.put(`${baseUrl}/allowances/approval`, body),
    editAllowanceAmount: (body) => axios.put(`${baseUrl}/allowances/edit/amount`, body),
    getAllowanceAggregatesList: (body) => axios.post(`${baseUrl}/allowances/aggregated-report`, body),
    getAllowanceAggregateExcel: (body) => axios.post(`${baseUrl}/allowances/aggregated-report/excel`, body),

}
export default allowanceService